import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { P404Component } from './pages/p404/p404.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { AuthorizedComponent } from './layout/authorized/authorized.component';
import { RoutingUrls } from '@cpak/enums';
import { MaintenanceGuard } from './guards/maintenance.guard';
import { MasterTemplateGuard } from './guards/master-template.guard';
import { P403Component } from './pages/p403/p403.component';

// Import Containers

export const routes: Routes = [
  {
    path: '',
    redirectTo: RoutingUrls.Dashboard,
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthorizedComponent,
    children: [
      {
        path: RoutingUrls.Dashboard,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.DashboardModule),
      },
      {
        path: RoutingUrls.Accounts,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.AccountsModule),
      },
      {
        path: RoutingUrls.Quotes,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.PakModule),
      },
      {
        path: RoutingUrls.Prototypes,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.PakModule),
      },
      {
        path: RoutingUrls.Catalog,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.CatalogModule),
        data: {
          breadcrumb: 'Catalog',
        },
      },
      {
        path: RoutingUrls.CompareProducts,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.CompareProductsModule),
      },
      {
        path: RoutingUrls.Search,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.SearchModule),
      },
      {
        path: RoutingUrls.Viewer,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.ModelViewerModule),
      },
      {
        path: RoutingUrls.Profile,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.ProfileModule),
      },
      {
        path: RoutingUrls.Maintenance,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.MaintenanceModule),
        canLoad: [MaintenanceGuard],
      },
      {
        path: `${RoutingUrls.MasterTemplates}/:id`,
        loadChildren: () => import('@cpak/main-features-lib').then(m => m.MasterTemplateModule),
        canLoad: [MasterTemplateGuard],
      },
      /* {
        path: RoutingUrls.BomTemplates,
        loadChildren: () => import('@cpak/features/pak').then(m => m.PakModule),
        canLoad: [BomTemplatesGuard],
      }, */
      {
        path: RoutingUrls.Forbidden,
        component: P403Component,
      },
      {
        path: RoutingUrls.NotFound,
        component: P404Component,
      },
    ],
  },
  {
    path: 'login/callback',
    component: CallbackComponent,
  },
  {
    path: '**',
    redirectTo: RoutingUrls.NotFound,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
